import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, List, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { FormSection } from "../shared/FormLayout";
import { EditAccountRootPaths } from "../accounts/AccountCard";
import { initUserAccountService, UserAccount } from "../security/userAccountService";

// Lists the accounts that use a profile, each linking to its account editor.
export const ProfileAccounts: FC<{ profileId: string }> = ({ profileId }) => {
  const [accounts, setAccounts] = useState<UserAccount[] | null>(null);

  useEffect(() => {
    initUserAccountService().getUsersForProfile(profileId).then((a) => setAccounts(a ?? []));
  }, [profileId]);

  return (
    <FormSection title={`Kontoer med denne profilen${accounts ? ` (${accounts.length})` : ""}`}>
      <Grid item xs={12}>
        {accounts === null ? (
          <Typography variant="body2" color="text.secondary">Henter kontoer…</Typography>
        ) : accounts.length === 0 ? (
          <Typography variant="body2" color="text.secondary">Ingen kontoer bruker denne profilen</Typography>
        ) : (
          <Paper variant="outlined" sx={{ maxHeight: 280, overflowY: "auto" }}>
            <List dense disablePadding>
              {accounts.map((a) => {
                const isPhone = a.type === "PhoneUserAccount";
                const primary = ("phoneNumber" in a && a.phoneNumber) || ("username" in a && a.username) || a.externalUserId;
                return (
                  <ListItemButton key={a.id} component={Link} to={EditAccountRootPaths[a.type](a)}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      {isPhone ? <LocalPhoneIcon fontSize="small" /> : <AlternateEmailIcon fontSize="small" />}
                    </ListItemIcon>
                    <ListItemText primary={primary} secondary={isPhone ? "Telefonkonto" : "AD-konto"} />
                  </ListItemButton>
                );
              })}
            </List>
          </Paper>
        )}
      </Grid>
    </FormSection>
  );
};
